import axios from 'axios';
import { utilService } from "../Utils/Utils/index";
import infSign from "@kugou/interface-signature"; 
import e from '../Utils/Event'
import AES from "@kugou/kg-aes";
import RSA from "@kugou/kg-rsa";

export const apiService = {
	/**
	 * 查看认证状态
	 * http://doc.kugou.net/showdoc-master/web/#/7?page_id=8588
	 * @param {*} appid 
	 * @param {*} clientver 
	 * @param {*} mid 
	 * @param {*} uuid 
	 * @param {*} dfid 
	 * @param {*} plat 
	 * @param {*} userid 
	 * @param {*} token 
	 */
	getIDCardAuth: function (appid, clientver, mid, uuid, dfid, plat, userid, token) {
		let data = {
            "appid": appid,
            "clientver": clientver,
			"mid": mid,
            "clienttime": parseInt(new Date().getTime() / 1000),
            "uuid": uuid,
            "dfid": dfid,
            "plat": plat,
			"userid": userid,
            "token": token,
            "real_auth": 1 // real_auth = 1，返回实名认证状态
		};

		return axios({
			method: 'get',
			url: "https://relationuser.kugou.com/v1/get_face_auth",
			params: data
		})
	},

	 /**
	  * 获取人脸核身认证token
	  * http://doc.kugou.net/showdoc-master/web/#/7?page_id=8588
	  * @param {*} baseInfo 
	  * @param {*} verifytype 身份证实名认证：0，人脸比对：1
	  * @param {*} ource 听：0，看：1，唱：2（新增找黄健）
	  * @param {*} name 
	  * @param {*} idno 
	  * @param {*} biz 业务来源
	  * @param {*} serviceType 选择第三方服务商，0：腾讯云，1：阿里云，默认0，2旷视 如果不传此参数，则由后端自动适配分配供应商出去
	  * @param {*} successcallback 
	  * @param {*} failcallback 
	  */
	getRealAuth: function(baseInfo, verifyType, source, name, idno, biz, serviceType, successcallback, failcallback) {
		const clienttime_ms = parseInt(new Date().getTime());
		
		let getData = {
            "appid": baseInfo.appid,
            "clientver":baseInfo.clientver,
			"mid": baseInfo.mid,
            "clienttime": clienttime_ms,
            "uuid": baseInfo.uuid,
            "dfid": baseInfo.dfid,
            "plat": baseInfo.plat,
        };
		let aesSource = {
			"token": baseInfo.token,
			"name": name,
			"idno": idno,
		}
		const encryptedObj = AES.encrypt(JSON.stringify(aesSource));
        let postData = {
            "userid": baseInfo.userid,
            "verifyType": verifyType ? verifyType : 0,
            "source": source ? source : 0,
			"biz": biz,
			pk: RSA.encrypt(JSON.stringify({
				clienttime: clienttime_ms,
				key: encryptedObj.key,
			  }), null, "PKCS1Padding"),
			params: encryptedObj.encryptedStr
        };
		if (serviceType === 0 || serviceType) {
			postData.serviceType = serviceType;
		}
		
        infSign(getData, postData, {
			useH5: true,
			postType: "json",
			log: false,
			callback: function(res) {
				getData = res;
				var getUrlParam = utilService.objToParamStr(getData);
	
				axios({
					method: "post",
					data: JSON.stringify(postData),
					url: "https://verifyservice.kugou.com/v3/get_real_auth?" + getUrlParam,
					dataType: "json",
					cache: false,
				}).then(function(response) {
					successcallback && successcallback(response);
				}).catch(function(err) {
					failcallback && failcallback(err);
				})
			}
		})
	},

	/**
	 * 人脸核身验证结果
	 * http://doc.kugou.net/showdoc-master/web/#/7?page_id=11061
	 * 
	 * @param {*} baseInfo 
	 * @param {*} serviceType 
	 * @param {*} verifyData 
	 * @param {*} biz 
	 * @param {*} successcallback 
	 * @param {*} failcallback 
	 */
	verifyIDCardInfo: function(baseInfo, serviceType, verifyData, biz, successcallback, failcallback) {
		const clienttime_ms = parseInt(new Date().getTime());
    e.emit('loading', true)
		let getData = {
            "appid": baseInfo.appid,
            "clientver": baseInfo.clientver,
			"mid": baseInfo.mid,
            "clienttime": clienttime_ms,
            "uuid": baseInfo.uuid,
            "dfid": baseInfo.dfid,
            "plat": baseInfo.plat,
        };

		let aesSource = {
			"token": baseInfo.token,
		}
		const encryptedObj = AES.encrypt(JSON.stringify(aesSource));
        let postData = {
            "userid": baseInfo.userid,
			"biz": biz,
			"serviceType": serviceType ? serviceType : 0, // 0是腾讯云 2是旷视
			
			pk: RSA.encrypt(JSON.stringify({
				clienttime: clienttime_ms,
				key: encryptedObj.key,
			  }), null, "PKCS1Padding"),
			params: encryptedObj.encryptedStr
        };

		if (serviceType === 0) {
			// 腾讯云
			postData.orderNo = verifyData.orderNo;
			postData.code = verifyData.code;
			postData.newSignature = verifyData.newSignature;
		}

		if (serviceType === 2) {
			// 旷视
			postData.meglive_data = verifyData.meglive_data;
			postData.biz_token = verifyData.biz_token;
		}

		infSign(getData, postData, {
			useH5: true,
			postType: "json",
			log: false,
			callback: function(res) {
				getData = res;
				var getUrlParam = utilService.objToParamStr(getData);

				axios({
					method: "post",
					data: JSON.stringify(postData),
					url: "https://verifyservice.kugou.com/v2/verify_real_auth?" + getUrlParam,
					dataType: "json",
					cache: false,
					timeout: 10000
				}).then(function(response) {
					e.emit('loading', false)
					successcallback && successcallback(response);
				}).catch(function(err) {
					e.emit('loading', false)
					failcallback && failcallback(err);
				})
			}
		})
	}

};